import { useMemo } from 'react'

import { Box } from '@percent/lemonade'
import { useQuery } from '@percent/workplace-giving/common/hooks'
import { getAccountAchievements } from '@percent/workplace-giving/api/account/achievements/achievements'
import { BadgeCard } from './BadgeCard'
import { BadgeCardSkeleton } from './BadgeCardSkeleton'
import classes from './MyAchievements.module.scss'

export function MyAchievements() {
  const { data, isPending } = useQuery(['getAccountAchievements'], getAccountAchievements)

  const groupedAchievements = useMemo(() => {
    if (!data?.rulesAndAchievements?.length) return []

    const grouped = new Map<string, typeof data.rulesAndAchievements[number] & { count: number }>()

    for (const item of data.rulesAndAchievements) {
      const existing = grouped.get(item.achievement.id)
      grouped.set(item.achievement.id, existing ? { ...existing, count: existing.count + 1 } : { ...item, count: 1 })
    }

    return [...grouped.values()]
  }, [data])

  if (isPending) {
    return (
      <Box pt={24} className={classes.Grid}>
        <BadgeCardSkeleton />
        <BadgeCardSkeleton />
        <BadgeCardSkeleton />
        <BadgeCardSkeleton />
        <BadgeCardSkeleton />
        <BadgeCardSkeleton />
      </Box>
    )
  }

  if (!groupedAchievements.length) {
    return null
  }

  return (
    <Box pt={24} className={classes.Grid}>
      {groupedAchievements.map(({ accountAchievement, achievement, rule, count }) => (
        <BadgeCard
          key={achievement.id}
          achievement={achievement}
          accountAchievement={accountAchievement}
          rule={rule}
          count={count}
        />
      ))}
    </Box>
  )
}
